 <ion-content>
  <canvas #myCanvas
  (touchstart)="handleTouchStart($event)"
  (touchmove)="handleTouchMove($event)"
  (touchend)="handleTouchEnd($event)"
  (mousedown)="handleMouseDown($event)"
  (mousemove)="handleMouseMove($event)"
  (mouseup)="handleMouseUp($event)"></canvas>
</ion-content>
